export default {
    userNameValidation: (value) => {
        const regex = new RegExp(/^[a-zA-Z0-9]{5,26}$/i)

        return !value || regex.test(value)
    }
}
